import { Iterable } from "@siteimprove/alfa-iterable";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Node } from "../../node.js";
const { isEmpty } = Iterable;
const { not } = Predicate;
/**
 * @public
 */
export function hasTextContent(predicate = not(isEmpty), options = Node.Traversal.empty) {
    return (node) => predicate(node.textContent(options));
}
//# sourceMappingURL=has-text-content.js.map